<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 产品名 -->
          <el-form-item label="id：" class="form-item-b0">
            <el-input
              v-model="query.userId"
              placeholder="请输入userId"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>

          <el-form-item label="搜索：" class="form-item-b0">
            <el-input
              v-model="query.search"
              placeholder="请输入搜索条件"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态：" class="form-item-b0">
            <el-select v-model="query.status" placeholder="请选择状态" @change="statusChange">
              <el-option label="未发货" :value="1"></el-option>
              <el-option label="待收货" :value="2"></el-option>
              <el-option label="已收货" :value="3"></el-option>
              <el-option label="售后中" :value="5"></el-option>
              <el-option label="已退款" :value="6"></el-option>
              <el-option label="已删除" :value="-1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型：" class="form-item-b0">
            <el-select v-model="query.orderType" placeholder="请选择状态">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="自提" :value="1"></el-option>
              <el-option label="快递" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>

          <el-button size="small" @click="init()">重置</el-button>

          <el-button type="success" size="mini" @click="allNumber">统计</el-button>

          <el-button type="danger" size="mini" @click="exportExcels">excel</el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" max-height="680" v-loading="loading">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table ref="TableListRef22" class="TableList" border :data="props.row.OrderItems">
            <el-table-column prop="SpecName" label="规格" width="auto" align="center"></el-table-column>

            <el-table-column prop="SpecCode" label="规格" width="auto" align="center"></el-table-column>

            <el-table-column prop="FCount" width="auto" label="数量" align="center"></el-table-column>

            <el-table-column prop="Price" width="auto" label="金额" align="center"></el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column type="index" width="50" align="center"> </el-table-column>

      <el-table-column prop="LoginName" label="UserId" width="130" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.UserId }}</div>
          <div>{{ new Date(scope.row.CreateTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="SpecName" label="规格" align="center"></el-table-column>

      <el-table-column prop="SpecCode" label="编号" align="center"></el-table-column>

      <el-table-column prop="FCount" width="68" label="数量" align="center"></el-table-column>

      <el-table-column prop="Price" width="68" label="金额" align="center"></el-table-column>

      <el-table-column prop="Freight" width="68" label="运费" align="center"></el-table-column>

      <el-table-column
        prop="RefundPrice"
        width="68"
        label="已退款"
        align="center"
        v-if="query.status === 6"
      ></el-table-column>

      <el-table-column prop="ReceiveAddress" width="280" label="地址" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.ReceiveName }} {{ scope.row.ReceivePhone }}</div>
          <div>{{ scope.row.ReceiveAddress }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="LogisticsName" width="180" label="物流" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.LogisticsName" filterable placeholder="请选择物流">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column prop="LogisticsNo" width="180" label="单号" align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.LogisticsNo" placeholder="单号"></el-input>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)"> 修改信息 </el-button>

          <br />

          <el-button
            style="margin-top: 6px; margin-left: 0"
            type="danger"
            size="mini"
            @click="onRefund(scope.row)"
            v-if="query.status === 5 && scope.row.Status === 5"
          >
            退款
          </el-button>

          <el-button
            style="margin-top: 6px; margin-left: 0"
            type="danger"
            size="mini"
            @click="recovery(scope.row)"
            v-else-if="query.status === -1 && scope.row.Status === -1"
          >
            复原
          </el-button>

          <el-button
            style="margin-top: 6px; margin-left: 0"
            type="success"
            size="mini"
            @click="onEditInfo(scope.row, 1)"
            v-else-if="query.status !== -1 && scope.row.Status !== -1"
          >
            发货
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 商户管理 -->
    <el-dialog
      :visible.sync="addDialog"
      class="FormDialogBox"
      width="680px"
      title="订单信息"
      :close-on-click-modal="false"
      append-to-body
      @close="addDialog = false"
    >
      <el-form label-width="auto" :model="addForm" ref="ruleForm">
        <el-form-item label="物流名称">
          <el-input v-model="addForm.logisticsName" placeholder="物流名称"></el-input>
        </el-form-item>

        <el-form-item label="物流单号">
          <el-input v-model="addForm.logisticsNo" placeholder="物流单号"></el-input>
        </el-form-item>

        <div style="display: flex">
          <el-form-item label="发货时间">
            <el-date-picker
              v-model="addForm.logisticsTime"
              type="date"
              placeholder="发货时间"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="收货时间" style="margin-left: 20px">
            <el-date-picker
              v-model="addForm.receiveTime"
              type="date"
              placeholder="收货时间"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="收货人">
            <el-input v-model="addForm.receiveName" placeholder="收货人"></el-input>
          </el-form-item>

          <el-form-item label="下单时间" style="margin-left: 20px">
            <span>
              {{ new Date(addForm.createTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}
            </span>
          </el-form-item>
        </div>

        <el-form-item label="收货电话">
          <el-input v-model="addForm.receivePhone" placeholder="收货电话"></el-input>
        </el-form-item>

        <el-form-item label="收货地址">
          <el-input v-model="addForm.receiveAddress" placeholder="收货地址"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="danger" @click="addDetermine()"> 确 定 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="orderDialog"
      class="FormDialogBox"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      @close="orderDialogClose"
    >
      <div style="min-height: 560px">
        <ShowTableInfo
          ref="ShowTableInfoRef2"
          :underPagination="false"
          :showItem="showItem2"
          :getListFn="getListFn2"
          :param="orderParam"
          :paramChangeGetList="true"
        >
          <template slot="ReceiveAddress" slot-scope="scope">
            <div>{{ scope.data.ReceiveName }} {{ scope.data.ReceivePhone }}</div>
            <div>{{ scope.data.ReceiveAddress }}</div>
          </template>

          <template slot="Status" slot-scope="scope">
            <span :style="{ color: `${scope.data.Status == 0 ? 'red' : ''}` }">{{
              statusType[scope.data.Status]
            }}</span>
          </template>

          <template slot="CreateTime" slot-scope="scope">
            <span>{{ new Date(scope.data.CreateTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="topUpDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="topUpDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef3"
          :underPagination="false"
          :showItem="showItem3"
          :getListFn="getListFn3"
          :param="topUpParam"
          :paramChangeGetList="true"
        >
          <template slot="CreateDate" slot-scope="scope">
            <span>{{ new Date(scope.data.CreateDate) | parseTime('{y}-{m}-{d} {h}:{m}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="accessDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="accessDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef4"
          :underPagination="false"
          :showItem="showItem4"
          :getListFn="getListFn4"
          :param="accessParam"
          :paramChangeGetList="true"
          :showPagination="false"
          :sortListFn="sortListFn"
        >
          <template slot="Date" slot-scope="scope">
            <span>{{ scope.data.Date }}</span>
            <span style="margin-left: 10px">{{ scope.data.Date | parseTime(`星期{a}`) }}</span>
          </template>

          <template slot="VipTime" slot-scope="scope">
            <span>{{ new Date(scope.data.VipTime) | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/exportExcel'

import { dataList } from './js/logisticsList.js'
console.log(dataList)

console.log(exportExcel)

export default {
  name: 'membersIndex',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,

      list: [],

      addDialog: false,
      addForm: {
        id: 0,
        productSpecId: 0,
        count: 1,
        price: 0,
        remark: '',
        productId: 0,
        logisticsName: '',
        logisticsNo: '',
        logisticsTime: '',
        createTime: '',
        receiveName: '',
        receivePhone: '',
        receiveAddress: '',
        receiveTime: '',
        payType: '1'
      },

      loading: true,
      total: 0,

      query: {
        pageindex: 1,
        pagesize: 20,
        categorize: 2,
        orderType: null,
        userId: '',
        search: '',
        status: 1
      },

      options: dataList,

      orderDialog: false,
      orderParam: {
        pageindex: 1,
        pagesize: 20,
        userId: '',
        integral: 0
      },
      orderList: [],
      showItem2: [
        {
          prop: 'OrderNo',
          label: '订单号'
        },
        {
          prop: 'SpecName',
          label: '兑换'
        },
        {
          prop: 'ReceiveAddress',
          label: '收货地址'
        },
        {
          prop: 'OrderIntegral',
          label: '积分'
        },
        {
          prop: 'FCount',
          label: '数量'
        },
        {
          prop: 'Status',
          label: '状态'
        },
        {
          prop: 'CreateTime',
          label: '创建时间'
        }
      ],

      statusType: {
        0: '未支付',
        1: '未发货',
        2: '已发货'
      },

      showItem3: [
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'GiveIntegral',
          label: '赠送积分'
        },
        {
          prop: 'Price',
          label: '价格'
        },
        {
          prop: 'CreateDate',
          label: '支付日期'
        },
        {
          prop: 'Remark',
          label: '备注'
        }
      ],
      topUpDialog: false,
      topUpParam: {
        pageindex: 1,
        pagesize: 20,
        search: '',
        status: 1
      },

      showItem4: [
        {
          prop: 'Date',
          label: '日期'
        },
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'VipTime',
          label: '会员'
        },
        {
          prop: 'LogCount',
          label: '访问次数'
        }
      ],
      accessDialog: false,
      accessParam: {
        begindate: this.$globalFun.parseTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 10),
          '{y}-{m}-{d}'
        ),
        enddate: this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        pageindex: 1,
        search: ''
      }
    }
  },

  created() {
    this.getList('place')
  },

  computed: {
    myImage: function () {
      const arr = []
      if (this.addForm.ImgUrl) {
        const list = this.addForm.ImgUrl.split(',')
        list.forEach((item) => {
          if (item) {
            arr.push({
              url: item
            })
          }
        })
      }
      return arr
    }
  },

  methods: {
    // 获取列表
    async getList(place) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        await this.$nextTick()
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      }

      console.log(this.query)

      const query = {
        ...this.query
      }

      if (!query.userId) {
        delete query.userId
      }

      try {
        const { data: res } = await this.$api.order.list(query)
        console.log('获取订单列表', res)

        this.list = res.list

        this.loading = false
        this.list = res.list
        this.total = res.count
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    statusChange(e) {
      console.log('statusChange', e)

      this.getList()
    },

    onEditInfo(data, type) {
      const logisticsTime =
        data.LogisticsTime && type === 1
          ? data.LogisticsTime
          : this.$globalFun.parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
      console.log('logisticsTime---', logisticsTime)

      const addForm = {
        id: data.OrderId,
        productSpecId: data.ProductSpecId,
        count: data.FCount,
        price: data.Price,
        remark: data.Remark,
        productId: data.ProductId,
        logisticsName: data.LogisticsName,
        logisticsNo: data.LogisticsNo,
        logisticsTime: data.LogisticsTime,
        createTime: data.CreateTime,
        receiveName: data.ReceiveName,
        receivePhone: data.ReceivePhone,
        receiveAddress: data.ReceiveAddress,
        receiveTime: data.ReceiveTime,
        orderType: data.OrderType
      }
      this.addForm = addForm

      if (type) {
        this.addDetermine(type)
        return
      }

      this.addDialog = true
    },

    async recovery(e) {
      console.log(e.OrderId)
      try {
        const { data } = await this.$api.order.cancel({
          id: e.OrderId
        })
        console.log('recovery', data)

        this.$message.success('恢复成功')
        this.getList()
      } catch (error) {
        console.log(error)
      }
    },

    async onRefund(e) {
      const maxRefundPrice = +(e.Price + e.Freight).toFixed(2)

      this.$prompt('请输入退款金额', `退款提示 金额最大为 ${maxRefundPrice}`, {
        confirmButtonText: '确定退款',
        cancelButtonText: '取消'
      })
        .then(async ({ value }) => {
          const refundPrice = Number(value)

          if (isNaN(refundPrice)) {
            this.$message({
              type: 'error',
              message: '请输入正确的退款金额'
            })
            return
          }

          if (refundPrice > maxRefundPrice) {
            this.$message({
              type: 'error',
              message: '退款金额不能大于订单金额'
            })
            return
          }

          try {
            const { data } = await this.$api.order.refund({
              id: e.OrderId,
              refundPrice
            })
            console.log('退款成功', data)

            this.$message({
              type: 'success',
              message: '退款成功'
            })

            this.getList()
          } catch (error) {
            this.$message({
              type: 'error',
              message: error
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消'
          })
        })
    },

    async onDelete(id) {
      this.$confirm('是否删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$api.order.delete({
          id
        })
        console.log('删除产品', data)

        this.$message.success('删除成功')
        this.getList()
      })
    },

    addOrder() {
      this.addForm = {
        id: 0,
        productSpecId: 0,
        count: 1,
        price: 0,
        remark: '',
        productId: 0,
        logisticsName: '',
        logisticsNo: '',
        logisticsTime: '',
        createTime: '',
        receiveName: '',
        receivePhone: '',
        receiveAddress: '',
        receiveTime: ''
      }

      this.addDialog = true
    },

    async addDetermine(type) {
      console.log('addForm', this.addForm)
      const addForm = {
        ...this.addForm
      }

      if (!addForm.logisticsTime) {
        delete addForm.logisticsTime
      }

      if (!addForm.receiveTime) {
        delete addForm.receiveTime
      }

      if (type) {
        if (!addForm.logisticsName || !addForm.logisticsName) {
          this.$message.error('请填写物流')
          return
        }

        addForm.logisticsTime = new Date()

        if (addForm.orderType === 1) {
          addForm.receiveTime = new Date()
        }
      }

      delete addForm.price
      console.log('addForm', addForm)

      const { data } = await this.$api.order.add(addForm)
      console.log('添加产品', data)

      this.addDialog = false
      this.getList()
    },

    async exportExcels() {
      const { data: res } = await this.$api.order.list({
        pageindex: 1,
        pagesize: 1000,
        status: 1,
        categorize: 2
      })
      console.log('获取订单列表', res)

      const list = res.list.sort((a, b) => {
        return a.ReceivePhone.localeCompare(b.ReceivePhone, 'zh-CN')
      })
      console.log('list', list[0])

      const headerList = [
        '订单编号',
        '收件人姓名',
        '收件人手机号',
        '收货地址',
        '商品名称',
        '商品数量',
        '规格名称',
        '备注'
      ]
      const valList = []
      list.forEach((item) => {
        valList.push([
          item.ReceiveName,
          item.ReceivePhone,
          item.ReceiveAddress,
          item.Title,
          item.FCount,
          item.SpecName,
          item.Remark
        ])
      })

      exportExcel(
        list,
        headerList,
        (item) => {
          return [
            item.OrderNo,
            item.ReceiveName,
            item.ReceivePhone,
            item.ReceiveAddress,
            item.Title,
            item.FCount,
            item.SpecName,
            item.Remark
          ]
        },
        '乡里仔订单信息.xlsx'
      )
    },

    async allNumber() {
      const { data: res } = await this.$api.order.list({
        pageindex: 1,
        pagesize: 1000,
        status: 1,
        categorize: 2
      })
      console.log('获取订单列表', res)

      const list = res.list

      const numObj = {}
      const num = []
      list.forEach((item) => {
        if (numObj[item.SpecName]) {
          numObj[item.SpecName] += item.FCount
        } else {
          numObj[item.SpecName] = item.FCount
        }

        if (!num.includes(item.ReceiveName + item.ReceivePhone)) {
          num.push(item.ReceiveName + item.ReceivePhone)
        }
      })
      console.log('numObj', numObj)

      let h = ''
      for (const key in numObj) {
        h += `<div>${key}: ${numObj[key]}</div>`
      }
      h += `<div>总计: ${num.length}人下单</div>`
      const d = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      this.$alert(h, d + ' 待发货', {
        dangerouslyUseHTMLString: true
      })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },

    getListFn2(query) {
      return this.$api.order.list(query)
    },

    async getUserOrderList(row) {
      this.orderParam = {
        ...this.orderParam,
        userId: row.UserId
      }

      this.orderDialog = true
    },

    orderDialogClose() {
      this.orderDialog = false
      this.orderList = []
    },

    getListFn3(query) {
      return this.$api.members.getTopUpWaterList(query)
    },

    getTopUpWaterList(search) {
      this.topUpParam = {
        ...this.topUpParam,
        search
      }

      this.topUpDialog = true
    },

    topUpDialogClose() {
      this.topUpDialog = false
    },

    getListFn4(query) {
      return this.$api.user.loglist(query)
    },

    sortListFn(list) {
      console.log('sortListFn111', list)
      return list.sort((a, b) => {
        return new Date(b.Date).getTime() - new Date(a.Date).getTime()
      })
    },

    getAccessList(search) {
      console.log('getAccessList', search)
      this.accessParam = {
        ...this.accessParam,
        search
      }

      this.accessDialog = true
    },

    accessDialogClose() {
      this.accessDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .data-list {
  width: 620px !important;

  ul.el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pre_img {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999988;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }

  .img {
    width: 20%;
    display: block;
  }
}
</style>
